import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import styled, { css } from 'styled-components'

export const Breadcrumbs = styled.div`
  padding: 30px 0;
  display: flex;

  @media ${DEVICES.mobile} {
    padding: 20px 0;
  }

  a,
  span {
    color: ${COLORS.grey[60]};
    text-decoration: none;
    margin-right: 10px;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    font-size: 14px;
    line-height: 20px;

    &:hover {
      color: ${COLORS.primary};
      text-decoration: underline;
    }

    svg {
      margin-left: 10px;
    }
  }

  span {
    color: ${COLORS.secondary};
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 0;

    &:hover {
      color: ${COLORS.secondary};
    }
  }

  ${({ secondary }) =>
    secondary &&
    css`
      padding: 0;
      position: relative;
      z-index: 5;
      a,
      span {
        color: ${COLORS.nature.base};

        &:hover {
          text-decoration: underline;
          color: ${COLORS.nature.base};
        }
      }

      span {
        text-decoration: underline;
      }
    `}
`
